import { render, staticRenderFns } from "./OptimizedEncoding.vue?vue&type=template&id=49b4b3e9&"
import script from "./OptimizedEncoding.vue?vue&type=script&lang=ts&"
export * from "./OptimizedEncoding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports